import { Box, Link, Typography } from "@mui/material";
import { useEffect, useState } from "react";

type Props = {
  text: string;
  maxLines?: number;
  variant?: "body1" | "body2";
  color?: "text.primary" | "text.secondary";
  emptyText?: string;
  gutterBottom?: boolean;
};

export default function ExpandableText({
  text,
  maxLines = 3,
  variant = "body2",
  color = "text.secondary",
  emptyText = "No text available",
  gutterBottom = false,
}: Props) {
  const [expanded, setExpanded] = useState(false);
  const [showMoreButton, setShowMoreButton] = useState(false);
  const [textRef, setTextRef] = useState<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!textRef) return;

    const isScrollable = textRef.scrollHeight > textRef.clientHeight;
    setShowMoreButton(isScrollable);
  }, [textRef, text]);

  return (
    <>
      <Box 
        ref={setTextRef}
        sx={{ 
          maxHeight: expanded ? 'none' : `${maxLines * 1.2}em`,
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <Typography 
          variant={variant}
          color={color}
          sx={{ whiteSpace: "pre-wrap" }}
          gutterBottom={gutterBottom && !showMoreButton}
        >
          {text.trim() || emptyText}
        </Typography>
      </Box>
      {showMoreButton && (
        <Link
          component="button"
          variant={variant}
          onClick={() => setExpanded(!expanded)}
          sx={{ mt: 0.5, mb: 1.5 }}
          gutterBottom={gutterBottom}
        >
          {expanded ? 'Show less' : 'Show more'}
        </Link>
      )}
    </>
  );
} 